import axios from "axios";

import { URLS } from "globalConstants";
import { store, history } from "helpers";
import { uiActions } from "store";
import { getIsOnline } from "store/ui/ui.reducer";

const instance = axios.create();

instance.interceptors.request.use(config => {
	const state = store.getState();
	const isOnline = getIsOnline(state);

	if (!isOnline) {
		store.dispatch(uiActions.showNoConnectionModal());
		throw new axios.Cancel("Network Error");
	}

	return config;
});

instance.interceptors.response.use(
	result => result,
	error => {
		if (error?.response?.status === 401) {
			history.replace(URLS.logout);
			return Promise.reject(error.response.data || "User unauthorized");
		}
		return Promise.reject(error);
	},
);

instance.interceptors.response.use(
	result => result,
	error => {
		if (error?.response?.status === 404) {
			return Promise.reject(error.response.data);
		}

		return Promise.reject(error);
	},
);

instance.interceptors.response.use(
	result => result,
	error => {
		if (error?.response?.status?.toString().startsWith("5")) {
			store.dispatch(uiActions.showServerErrorModal(error.response));

			return Promise.reject({
				message: "No connection to server",
			});
		}

		return Promise.reject(error);
	},
);

export { instance as axios };
